import React from "react";
import "./styles";

function OrvpReport(props) {
  return (
    <tr className="editor__orvp_report">
      <td className="clear_background">{props.id}</td>
      <td className="clear_background">{props.place.canonical_place_id}</td>
      <td className="clear_background">{props.place.name}</td>
      <td className="clear_background">{props.place.city}</td>
      <td className="clear_background">{props.parking_allowed ? 'Yes' : 'No'}</td>
      <td className="clear_background">{props.user_stay ? 'Yes' : 'No'}</td>
      <td className="clear_background">{props.policy_enforced}</td>
      <td className="clear_background">{props.parking_confirmed ? 'Yes' : 'No'}</td>
      <td className="clear_background">{props.created_at}</td>
      <td className="clear_background">{props.state}</td>
      <td className="editor__orvp_report__date_stayed"><span className="bold">Date Stayed:</span> {props.user_stay_date}</td>
      <td className="editor__orvp_report__restricted_by"><span className="bold">Restricted By:</span> {props.restricted_by}</td>
      <td className="editor__orvp_report__confirmation_method"><span className="bold">Confirmation Method:</span> {props.policy_confirmation_method}</td>
      <td className="editor__orvp_report__confirmed_by"><span className="bold">Confirmed By:</span> {props.policy_confirmed_by}</td>
      <td className="editor__orvp_report__confirmed_date"><span className="bold">Confirmed Date:</span> {props.policy_confirmation_date}</td>
      <td className="editor__orvp_report__place_correct"><span className="bold">Place Correct:</span> {props.place_correct}</td>
      <td className="editor__orvp_report__comment"><span className="bold">Comment:</span> {props.comment}</td>
    </tr>
  );
}

export default OrvpReport;
